module.exports = __webpack_public_path__ + "deliveroo.svg?deb24c14844a857ccc588e233bb4f66c";